// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconSparkleGradient.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

// This icon carries its own colours and does not follow the surrounding text colour.
const IconSparkleGradient = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="none" { ...props }>
    <path d="M14.044 14.5134C11.7653 12.6846 10.5281 11.6968 8.94866 11.4034C6.65037 10.9829 4.56235 12.2152 3.43276 13.0513C3.78484 12.6357 5.45721 10.5623 5.19804 7.59902C5.00733 5.44254 3.89731 3.99511 3.44743 3.47188C3.98533 3.91198 5.50611 5.02689 7.7555 5.17359C10.5868 5.35452 12.5623 3.86308 13.0318 3.48655C10.8313 6.44988 11.154 8.55746 11.3056 9.22249C11.5746 10.401 12.5477 11.6968 14.5037 14.2836C15.022 14.9682 15.4817 15.5501 15.8386 15.9951H16V8C15.9951 3.57946 12.4156 0 8 0C3.58435 0 0 3.57946 0 8C0 12.4156 3.57946 16 8 16H15.7653C15.3203 15.5844 14.7384 15.0709 14.044 14.5134Z" fill="url(#IconSparkleGradient_fill)" />
    <defs>
      <linearGradient id="IconSparkleGradient_fill" x1="13.6267" y1="-3.93407" x2="-6.20034" y2="6.29991" gradientUnits="userSpaceOnUse">
        <stop stopColor="#B364F8" />
        <stop offset="1" stopColor="#678BFF" />
      </linearGradient>
    </defs>
  </BaseIcon>
);

export default IconSparkleGradient;
